import { Button, chakra, Flex } from "@chakra-ui/react";
import { fonts, space } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const DeprecatedChakraButtonsWrapper = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    textAlign: "center",
    pb: { base: 0 },
    pt: 0,
    width: "100%",
    borderBottom: `1px solid ${colours.secondary.deep}`
  }
});

export const DeprecatedChakraBlackButton = chakra(Button, {
  baseStyle: {
    gridColumn: { base: "span 6", lg: "span 4" },
    minHeight: space[5],
    "&>button": {
      fontFamily: fonts.acuminRegular,
      fontSize: 1,
      py: -2,
      width: "100%",
      ":hover": {
        backgroundColor: "black !important"
      }
    }
  }
});

export const DeprecatedChakraWhiteButton = chakra(Button, {
  baseStyle: {
    width: "100%",
    fontFamily: fonts.acuminRegular,
    fontSize: 1,
    backgroundColor: colours.secondary.light,
    color: colours.primary.dark,
    margin: 0,
    textTransform: "initial",
    mt: space["1.75"],
    borderRadius: 2,
    minHeight: space[5],
    "&:hover": {
      backgroundColor: colours.secondary.light,
      color: colours.primary.dark
    }
  }
});
